export default __webpack_public_path__ + "static/media/todo-mobile-2.a5354be7.png";